<template>
  <b-row>
    <b-col>
      <cabecalho-repeticao
        :titulo="'Sócio'"
        :show-icon="true"
        :tags="tags"
        :exibe-tag="exibeTag"
        @apply="adicionarItem()"
        @remove="removerItem()"
      >
        <template
          v-if="showinfo && !valueInner.veioDoHub"
          #info
        >
          <info-checklist
            :item-id="valueInner.id > 0 ? valueInner.id.toString() : getCodeValidation()"
            :item="valueInner"
          />
        </template>

        <template
          v-if="(showinfo && !valueInner.veioDoHub) && !habilitarCampo"
          #edit
        >
          <b-btn
            v-b-tooltip.hover
            variant="none"
            title="Alterar"
            class="btn-outline-primary btn-none rounded-pill icone-acao mr-50"
            style="margin-top: -0.3rem;"
            @click="$refs.modalJustificativa.show()"
          >
            <feather-icon icon="EditIcon" />
          </b-btn>
        </template>
      </cabecalho-repeticao>

      <!-- Modal de justificativa -->
      <modal-justificativa
        id="'modalJustificativa'"
        :ref="'modalJustificativa'"
        :texto-apresentacao="'Informe o motivo da alteração'"
        @cancelar="cancelar()"
        @confirmar="confirmar($event)"
      />

      <!-- Dados do sócio -->
      <b-row
        v-if="(mostrarOcultar && valueInner.usuarioJaExistenteNoHub && !socio.veioDoHub) && (valueInner.atualizarDados === undefined || valueInner.atualizarDados === null)"
        style="color: red; font-weight: 500;padding-left: 1rem;"
      >
        Seleção Obrigatória!
      </b-row>
      <b-row
        v-if="mostrarOcultar && valueInner.usuarioJaExistenteNoHub && !socio.veioDoHub"
        style="padding-left: 1rem;"
      >
        <span class="mb-2">Esse sócio já está cadastrado no Sistema, o que deseja fazer com os dados gerais do
          cadastro?</span>
        <b-form-radio-group
          v-model="valueInner.atualizarDados"
          :options="[{ text: 'Atualizar', value: true }, { text: 'Não Atualizar', value: false }]"
          :name="`atualizar-dados-socio-${valueInner.code}`"
          class="ml-50"
        />
      </b-row>
      <b-row>
        <b-col cols="10">
          <div
            :class="mostrarOcultar ? 'separar' : ''"
            style="display: flex;margin-bottom: 0.8rem;"
          >
            <div
              v-if="mostrarOcultar"
              style="margin-right: 4rem;"
            >
              <b-form-checkbox
                v-model="valueInner.ocultarDoContrato"
                :value="true"
                :unchecked-value="false"
                :disabled="valueInner.responsavelRFB"
                class="mb-50"
                @change="ocultarSocio"
              >
                Ocultar esse sócio do contrato
              </b-form-checkbox>
            </div>
            <div style="margin-right: 4rem;">
              <b-form-checkbox
                v-model="valueInner.socioAdministrador"
                :disabled="valueInner.veioDoHub || disabled"
                class="checkbox"
              >
                Sócio administrador <span class="text-danger">*</span>
              </b-form-checkbox>
            </div>
            <div style="margin-left: 1rem;">
              <b-form-checkbox
                v-model="valueInner.responsavelRFB"
                :disabled="valueInner.veioDoHub || disabled"
                class="checkbox"
                @change="adicionarContratante($event)"
              >
                Responsável perante a RFB <span class="text-danger">*</span>
              </b-form-checkbox>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group>
            <template #label>
              Sócio <span class="text-danger">*</span>
            </template>
            <b-input
              v-model="valueInner.nome"
              :disabled="valueInner.veioDoHub || valueInner.veioDoRFB || desabilitarNome"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <template #label>
              Tipo de inscrição <span class="text-danger">*</span>
            </template>
            <b-select
              ref="tipoInscricao"
              v-model="valueInner.tipoInscricao"
              :options="opcoesInscricao"
              :disabled="valueInner.veioDoHub || disabled"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <template #label>
              Inscrição <span class="text-danger">*</span>
            </template>
            <validation-provider
              #default="{ errors }"
              :rules="externo && (!valueInner.veioDoHub) || habilitarCampo ? 'required' : ''"
              :vid="getCodeValidation()"
            >
              <inscricao-federal
                ref="inscricao"
                v-model="valueInner.inscricao"
                :tipo-inscricao="valueInner.tipoInscricao"
                :disabled="valueInner.veioDoHub || disabled"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >Campo obrigatório</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <div>
        <b-row>
          <b-col cols="3">
            <b-form-group label="Data de nascimento">
              <validation-provider
                #default="{ errors }"
                :rules="externo && (!valueInner.veioDoHub) || habilitarCampo ? 'required' : ''"
                :vid="getCodeValidation()"
              >
                <data-input
                  v-model="valueInner.dataNascimento"
                  :disabled="valueInner.veioDoHub || disabled"
                />
                <small
                  v-if="errors[0]"
                  class="text-danger"
                >Campo obrigatório</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="Profissão">
              <validation-provider
                #default="{ errors }"
                :rules="externo && (!valueInner.veioDoHub) || habilitarCampo ? 'required' : ''"
                :vid="getCodeValidation()"
              >
                <b-form-input
                  v-model="valueInner.profissao"
                  class="desabilitar"
                  :disabled="valueInner.veioDoHub || disabled"
                />
                <small
                  v-if="errors[0]"
                  class="text-danger"
                >Campo obrigatório</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <validation-provider
              #default="{ errors }"
              :rules="externo && (!valueInner.veioDoHub) || habilitarCampo ? 'required' : ''"
              :vid="getCodeValidation()"
            >
              <funcao-select
                v-model="valueInner.funcao"
                :disabled="valueInner.veioDoHub || disabled"
                :require="false"
                class="desabilitar"
                :externo="externo"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >Campo obrigatório</small>
            </validation-provider>
          </b-col>
          <b-col cols="3">
            <b-form-group label="Nacionalidade">
              <validation-provider
                #default="{ errors }"
                :rules="externo && (!valueInner.veioDoHub) || habilitarCampo ? 'required' : ''"
                :vid="getCodeValidation()"
              >
                <b-form-input
                  v-model="valueInner.nacionalidade"
                  :disabled="valueInner.veioDoHub || disabled"
                  @keypress="isLetter($event)"
                />
                <small
                  v-if="errors[0]"
                  class="text-danger"
                >Campo obrigatório</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group label="Estado Civil">
              <validation-provider
                #default="{ errors }"
                :rules="externo && (!valueInner.veioDoHub) || habilitarCampo ? 'required' : ''"
                :vid="getCodeValidation()"
              >
                <b-form-select
                  v-model="valueInner.estadoCivil"
                  :options="opcoesEstadoCivil"
                  :disabled="valueInner.veioDoHub || disabled"
                />
                <small
                  v-if="errors[0]"
                  class="text-danger"
                >Campo obrigatório</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="RG">
              <b-input
                v-model="valueInner.rg"
                :disabled="valueInner.veioDoHub || disabled"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="Órgão Emissor">
              <orgao-emissor-select
                v-model="valueInner.orgaoEmissor"
                :externo="externo"
                :disabled="valueInner.veioDoHub || disabled"
              />
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-form-group label="UF">
              <estado-select
                v-model="valueInner.ufUsuario"
                class="desabilitar"
                :externo="externo"
                :disabled="valueInner.veioDoHub || disabled"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <div class="div-email">
              <div>
                <legend style="font-size: 14px;">
                  E-mail</legend>
              </div>
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  title="O e-mail informado nesse campo será enviado o contrato e também o convite de acesso para o portal do Honorarium."
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon :icon="faQuestionCircle" />
                </i>
              </div>
            </div>
            <validation-provider
              #default="{ errors }"
              :rules="externo && (!valueInner.veioDoHub) || habilitarCampo ? 'required|email' : 'email'"
              :vid="getCodeValidation()"
              name="E-mail"
            >
              <b-form-input
                v-model="valueInner.email"
                :disabled="valueInner.veioDoHub || disabled"
                placeholder="Nesse email será enviado o contrato para assinar"
                :formatter="formatter"
                @input="verificaEmailDuplicado($event)"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >{{ 'Campo obrigatorio' }}</small>
              <small
                v-if="erroEmail"
                class="text-danger"
              >E-mail duplicado</small>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <telefone-celular
              :value="valueInner.telefoneContato"
              :disabled="valueInner.veioDoHub || disabled"
              :ocultar-do-contrato="valueInner.ocultarDoContrato"
              :exibe-checks-envia-contrato="!externo"
              @altera-checks-envia-comtrato="ocultarSocio"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="mb-1"
            cols="12"
            style="display: flex; align-items: center;"
          >
            <div>
              <legend class="col-form-label pt-0" />
              <b-form-checkbox
                v-model="valueInner.residenteExterior"
                :disabled="valueInner.veioDoHub || disabled"
                class="checkbox checkbox-residente-exterior"
                @change="limparEndereco"
              >
                Residente no exterior
              </b-form-checkbox>
            </div>
            <fieldset class="divisoria-resisdente-exterior" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <cep-input
              :value="valueInner.cep"
              :externo="externo"
              :disable="valueInner.veioDoHub || disabled || valueInner.residenteExterior"
              @atualizar-endereco="enderecoBuscado"
            />
          </b-col>
          <b-form-group
            label="Endereço"
            class="col-md-6"
          >
            <validation-provider
              #default="{ errors }"
              :rules="((externo && !valueInner.veioDoHub) || habilitarCampo) && !valueInner.residenteExterior ? 'required' : ''"
              :vid="getCodeValidation()"
            >
              <b-form-input
                v-model="valueInner.logradouro"
                :disabled="valueInner.veioDoHub || disabled || valueInner.residenteExterior"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >Campo obrigatório</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Número"
            class="col-md-3"
          >
            <validation-provider
              #default="{ errors }"
              :rules="((externo && !valueInner.veioDoHub) || habilitarCampo) && !valueInner.residenteExterior ? 'required' : ''"
              :vid="getCodeValidation()"
            >
              <b-form-input
                v-model="valueInner.numero"
                :disabled="valueInner.veioDoHub || disabled || valueInner.residenteExterior"
                @keypress="isNumber($event)"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >Campo obrigatório</small>
            </validation-provider>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group
            label="Complemento"
            class="col-md-3"
          >
            <b-form-input
              v-model="valueInner.complemento"
              :disabled="valueInner.veioDoHub || disabled || valueInner.residenteExterior"
            />
          </b-form-group>
          <b-form-group
            label="Bairro"
            class="col-md-4"
          >
            <validation-provider
              #default="{ errors }"
              :rules="((externo && !valueInner.veioDoHub) || habilitarCampo) && !valueInner.residenteExterior ? 'required' : ''"
              :vid="getCodeValidation()"
            >
              <b-form-input
                v-model="valueInner.bairro"
                :disabled="valueInner.veioDoHub || disabled || valueInner.residenteExterior"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >Campo obrigatório</small>
            </validation-provider>
          </b-form-group>
          <b-col cols="3">
            <legend class="col-form-label pt-0">
              Cidade
            </legend>
            <validation-provider
              #default="{ errors }"
              :rules="((externo && !valueInner.veioDoHub) || habilitarCampo) && !valueInner.residenteExterior ? 'required' : ''"
              :vid="getCodeValidation()"
            >
              <municipio-select
                v-model="valueInner.cidade"
                :disabled="valueInner.veioDoHub || disabled || valueInner.residenteExterior"
                class="desabilitar"
                :externo="externo"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >Campo obrigatório</small>
            </validation-provider>
          </b-col>
          <b-col cols="2">
            <legend class="col-form-label pt-0">
              Estado
            </legend>
            <validation-provider
              #default="{ errors }"
              :rules="((externo && !valueInner.veioDoHub) || habilitarCampo) && !valueInner.residenteExterior ? 'required' : ''"
              :vid="getCodeValidation()"
            >
              <estado-select
                v-model="valueInner.uf"
                :disabled="valueInner.veioDoHub || disabled || valueInner.residenteExterior"
                class="desabilitar"
                :externo="externo"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >Campo obrigatório</small>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <upload-socio
              :ref="`upload${valueInner.code}`"
              :label="'Anexe aqui um documento (CNH ou RG)'"
              :id-upload="valueInner.code"
              :text="valueInner.nomeArquivoQualificacao"
              :visualizar="visualizarQualificacaoSocio"
              :disabled="desabilitaAnexo && habilitarCampo"
              :desabilitar-lixeira="(!externo || enviadoAnalise) && habilitarCampo"
              @removido="removerArquivo"
              @selecionado="arquivoSelecionado"
            />
          </b-col>
        </b-row>
      </div>

    </b-col>
  </b-row>
</template>

<style lang="scss">
.icone-mais {
  padding: 0.4rem 1rem;
}

.desabilitar .vs--disabled .vs__dropdown-toggle,
.desabilitar .vs--disabled .vs__search {
  background-color: #efefef;
}

.checkbox .custom-control-label {
  color: #6e6b7b !important;
}

.separar {
  justify-content: space-between;
}

.div-email {
  display: flex;
}

.checkbox-residente-exterior label {
  font-size: 12px !important;
}

.divisoria-resisdente-exterior {
  width: 82%;
  border-bottom: 1px solid;
  opacity: 0.3;
  margin-top: 8px;
}
</style>

<script>
import { generateCode, aplicaMascara } from '@core/utils/utils'
import { ValidationProvider } from 'vee-validate'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import preGeracaoApi from '@/app-modulo/comercial/cadastro-proposta/shared/components/pre-geracao-contrato-proposta/services/api'

export default {
  name: 'SocioEmpresaContrato',
  components: {
    ValidationProvider,
    FontAwesomeIcon,
    CabecalhoRepeticao: () => import('@/shared/components/cabecalho-repeticao/CabecalhoRepeticao.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    OrgaoEmissorSelect: () => import('@/shared/components/orgao-emissor-select/OrgaoEmissorSelect.vue'),
    FuncaoSelect: () => import('@/shared/components/funcao-select/FuncaoSelect.vue'),
    EstadoSelect: () => import('@/shared/components/estado-select/EstadoSelect.vue'),
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
    MunicipioSelect: () => import('@/shared/components/municipio-select/MunicipioSelect.vue'),
    UploadSocio: () => import('@/shared/components/upload-socio/UploadSocio.vue'),
    InfoChecklist: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/shared/components/InfoChecklist.vue'),
    ModalJustificativa: () => import('@/shared/components/modal-justificativa/ModalJustificativa.vue'),
    InscricaoFederal: () => import('@/shared/components/inscricao-federal/InscricaoFederal.vue'),
    CepInput: () => import('@/@pilar/components/cep-input/CepInput.vue'),
  },
  props: {
    socio: {
      type: Object,
      default: () => { },
    },
    desabilitarNome: {
      type: Boolean,
      default: true,
    },
    externo: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mostrarOcultar: {
      type: Boolean,
      default: false,
    },
    showinfo: {
      type: Boolean,
      default: false,
    },
    desabilitaAnexo: {
      type: Boolean,
      default: false,
    },
    enviadoAnalise: {
      type: Boolean,
      default: false,
    },
    listaEmails: {
      type: Array,
      default: () => [],
    },
    habilitarCampo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faQuestionCircle,
      valueInner: {
        nome: null,
        inscricao: null,
        tipoInscricao: 'cpf',
        veioDoRFB: false,
        veioDoHub: false,
        atualizarDados: null,
        socioJaExisteNoHub: false,
        residenteExterior: false,
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
          enviaContratoTelefone: false,
          enviaContratoCelular: false,
        },
        code: generateCode(),
      },
      opcoesEstadoCivil: ['', 'Solteiro (a)', 'Casado (a)', 'Separado (a)', 'Divorciado (a)', 'Viúvo (a)'],
      opcoesInscricao: [{ value: 'cpf', text: 'CPF' }, { value: 'cnpj', text: 'CNPJ' }],
      tag: {
        id: 1,
        cor: '#7BC86C',
        descricao: '',
      },
      tagAtencao: {
        id: 2,
        cor: '#FFAF3F',
        descricao: 'Atenção',
      },
      tags: [],
      exibeTag: false,
      erroEmail: false,
      componenteTelefoneKey: 0,
    }
  },
  watch: {
    socio(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        this.valueInner.code = this.valueInner.id > 0 ? this.valueInner.id.toString() : generateCode()
        this.valueInner.inscricao = aplicaMascara(value.inscricao)
      }
    },
  },
  created() {
    this.valueInner = this.socio
    this.exibeTag = (this.valueInner.veioDoHub || this.valueInner.veioDoRFB) && this.painel
    this.setDescricaoTag()
    this.valueInner.code = this.valueInner.id > 0 ? this.valueInner.id.toString() : generateCode()
    this.valueInner.inscricao = aplicaMascara(this.socio.inscricao)
  },
  methods: {
    enderecoBuscado(value) {
      this.$set(this.valueInner, 'logradouro', value.logradouro)
      this.$set(this.valueInner, 'bairro', value.bairro)
      this.$set(this.valueInner, 'complemento', value.complemento)
      this.$set(this.valueInner, 'uf', value.uf)
      this.$set(this.valueInner, 'cidade', value.cidade)
      this.$set(this.valueInner, 'cep', value.cep)
    },
    formatter(value) {
      return value.toLowerCase()
    },
    getCodeValidation() {
      return generateCode()
    },
    adicionarContratante(value) {
      this.$emit('verificar-responsavel', { socio: this.valueInner, responsavel: value })
      this.$emit('adicionar-contratante', { responsavel: value, contratante: this.valueInner })
    },
    visualizarQualificacaoSocio() {
      return preGeracaoApi.getQualificacaoSocio(this.valueInner.id, this.externo)
    },
    adicionarItem() {
      this.$emit('adicionar-item')
    },
    removerItem() {
      if (this.valueInner.veioDoRFB || this.valueInner.veioDoHub) {
        this.$erro('Não é permitido remover o sócio')
      } else {
        this.$emit('remover-item')
      }
    },
    // eslint-disable-next-line consistent-return
    isLetter(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[A-Za-z]+$/.test(char)) return true
      e.preventDefault()
    },
    // eslint-disable-next-line consistent-return
    isNumber(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[0-9]+$/.test(char)) return true
      e.preventDefault()
    },
    editarSocio() {
      this.$emit('editar-socio', this.valueInner)
    },
    cancelar() {
      this.$refs.modalJustificativa.hide()
    },
    confirmar(mensagem) {
      const justSemEspaco = mensagem.replace(/\s+/g, '')
      if (!mensagem || justSemEspaco.length < 10) {
        this.$erro(!mensagem ? 'A justificativa para a alteração é obrigatória.' : 'A justificativa deve ter no mínimo 10 caracteres!')
      } else {
        this.$set(this.valueInner, 'justificativa', mensagem)
        this.editarSocio()
        this.$refs.modalJustificativa.hide()
      }
    },
    setDescricaoTag() {
      if (this.valueInner.veioDoHub) {
        this.tag.descricao = 'Importado via Honorarium'
      } else if (this.valueInner.veioDoRFB) {
        this.tag.descricao = 'Importado via RFB'
      }
      this.tags.push(this.tag)
    },
    addValuesAtualizar() {
      this.$set(this.valueInner, 'atualizarDados', true)
    },
    addValuesNaoAtualizar() {
      this.$set(this.valueInner, 'atualizarDados', false)
    },
    removerArquivo() {
      this.valueInner.nomeArquivoQualificacao = null
    },
    arquivoSelecionado(nome) {
      this.valueInner.nomeArquivoQualificacao = nome
    },
    verificaEmailDuplicado(value) {
      this.erroEmail = false
      if (this.listaEmails && this.listaEmails.length > 1) {
        if (value && value !== '' && this.listaEmails.some(som => som.email === value && ((som.id ? som.id : som.code) !== (this.valueInner.id ? this.valueInner.id : this.valueInner.code)))) {
          this.erroEmail = true
        }
      }
    },
    limparEndereco(event) {
      if (event) {
        this.$set(this.valueInner, 'logradouro', null)
        this.$set(this.valueInner, 'bairro', null)
        this.$set(this.valueInner, 'complemento', null)
        this.$set(this.valueInner, 'uf', null)
        this.$set(this.valueInner, 'cidade', null)
        this.$set(this.valueInner, 'cep', null)
        this.$set(this.valueInner, 'numero', null)

        this.$emit('limparEndereco', this.valueInner)
      }
    },
    ocultarSocio() {
      this.$emit('ocultar-socio')
      if (this.valueInner.ocultarDoContrato) {
        this.$set(this.valueInner.telefoneContato, 'enviaContratoTelefone', false)
        this.$set(this.valueInner.telefoneContato, 'enviaContratoCelular', false)
      }
    },
  },
}
</script>
